export type RHDateInput = Date | string | number | null | undefined

export function dateFromRHDateInput(value: RHDateInput): Date | undefined {
    if (value === null || value === undefined || value === "") {
        return undefined
    }

    const date = new Date(value)
    if (isNaN(date.getTime())) {
        return undefined
    }
    return date
}

export function formatRHDate(date: Date): string {
    const day = String(date.getDate()).padStart(2, "0")
    const month = String(date.getMonth() + 1).padStart(2, "0")
    return `${day}.${month}.${date.getFullYear()}`
}

export function formatRHTime(date: Date): string {
    const hours = String(date.getHours()).padStart(2, "0")
    const minutes = String(date.getMinutes()).padStart(2, "0")
    return `${hours}:${minutes}`
}

export function formatRHTimeWithSeconds(date: Date): string {
    const hours = String(date.getHours()).padStart(2, "0")
    const minutes = String(date.getMinutes()).padStart(2, "0")
    const seconds = String(date.getSeconds()).padStart(2, "0")
    return `${hours}:${minutes}:${seconds}`
}

export function formatRHDateTime(date: Date): string {
    return `${formatRHDate(date)} ${formatRHTime(date)}`
}

// Date on one line, time on the next. UITextView renders its text as innerHTML,
// so an HTML <br> forces the break; a plain "\n" collapses to a space under the
// cell's white-space rules. Cells that use this must also set the label to
// multi-line (titleLabel.isSingleLine = NO) so both lines are measured and shown.
export function formatRHDateTimeWithLineBreak(date: Date): string {
    return `${formatRHDate(date)}<br>${formatRHTime(date)}`
}

export function formatRHDateTimeWithSeconds(date: Date): string {
    return `${formatRHDate(date)} ${formatRHTimeWithSeconds(date)}`
}

export function formatRHDateValue(value: RHDateInput, fallback = ""): string {
    const date = dateFromRHDateInput(value)
    return date ? formatRHDate(date) : fallback
}

export function formatRHDateTimeValue(value: RHDateInput, fallback = ""): string {
    const date = dateFromRHDateInput(value)
    return date ? formatRHDateTime(date) : fallback
}

export function formatRHDateTimeWithSecondsValue(value: RHDateInput, fallback = ""): string {
    const date = dateFromRHDateInput(value)
    return date ? formatRHDateTimeWithSeconds(date) : fallback
}

// Formats a contract date-range duration for display. A missing start renders as
// "kuni <end>" and a missing end as "alates <start>", instead of an ugly "? – <date>".
export function formatRHContractDateRange(
    startDate?: string | Date | null,
    endDate?: string | Date | null
): string {
    let start: string | undefined = undefined
    if (startDate) {
        start = formatRHDate(new Date(startDate))
    }
    let end: string | undefined = undefined
    if (endDate) {
        end = formatRHDate(new Date(endDate))
    }
    if (start && end) {
        return `${start} – ${end}`
    }
    if (end) {
        return `kuni ${end}`
    }
    if (start) {
        return `alates ${start}`
    }
    return "Määramata"
}
